import Vue from "vue";
import VueRouter from "vue-router";
import Store from "./js/vuex-store";
import StepByStepGuide from "./components/step-by-step-guide/StepByStepGuide.vue";
import GuideStep from "./components/step-by-step-guide/guide-step/GuideStep.vue";

Vue.use(VueRouter);

const routes = [
  { path: "/", component: StepByStepGuide },
  { path: "/:stepIds", component: StepByStepGuide },
];
const Router = new VueRouter({ routes });

if (document.querySelector("#step-app")) {
  new Vue({
    el: "#step-app",
    store: Store,
    router: Router,
    components: {
      StepByStepGuide,
      GuideStep
    },
  });
}